<template>
  <div class="cooperation-page__files-header">
    <div v-html="title" class="cooperation-page__files-header-title" :style="{ borderColor }"/>

    <div
      v-if="date"
      class="cooperation-page__files-timer"
      :class="{ finished: !left }"
    >
      <span class="cooperation-page__files-timer-title">{{$tCooperation('Time passed')}}</span>

      <div class="cooperation-page__files-timer-counter">
        <div class="cooperation-page__files-timer-section days">
          <span class="cooperation-page__files-timer-number">{{daysFormatted}}</span>
          <span class="cooperation-page__files-timer-subtitle">{{$tCooperation('days')}}</span>
        </div>

        <div class="cooperation-page__files-timer-section hours">
          <span class="cooperation-page__files-timer-number">{{hoursFormatted}}</span>
          <span class="cooperation-page__files-timer-subtitle">{{$tCooperation('hours')}}</span>
        </div>

        <div class="cooperation-page__files-timer-section minutes">
          <span class="cooperation-page__files-timer-number">{{minutesFormatted}}</span>
          <span class="cooperation-page__files-timer-subtitle">{{$tCooperation('minutes')}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      date: Date,
      title: String,
      borderColor: String
    },

    data() {
      return {
        currentDate: Date.now()
      };
    },

    computed: {
      left() {
        return !this.date ? 0 : Math.max(0, (this.currentDate - this.date.getTime()) / 1000);
      },

      days() {
        return Math.floor(this.left / (3600 * 24));
      },

      hours() {
        return Math.floor(this.left / 3600) - (this.days * 24);
      },

      minutes() {
        return Math.floor(this.left / 60) - (this.days * 24 * 60) - (this.hours * 60);
      },

      daysFormatted() {
        return this.days < 10 ? '0' + this.days : this.days;
      },

      hoursFormatted() {
        return this.hours < 10 ? '0' + this.hours : this.hours;
      },

      minutesFormatted() {
        return this.minutes < 10 ? '0' + this.minutes : this.minutes;
      }
    },

    mounted() {
      setInterval(() => this.currentDate = Date.now(), 1000);
    }
  };
</script>
